/* eslint-disable react/no-unescaped-entities */
import { LegalShell } from "./LegalShell";

export default function DataDeletion() {
  return (
    <LegalShell title="Data Deletion Instructions" updated="February 18, 2026">
      <p>
        You can delete your <strong>b→come</strong> account and all data associated with it at any time.
        Here's how:
      </p>

      <h2>Option 1 — Delete from inside the app</h2>
      <ol className="mt-3 list-decimal space-y-2 pl-6 text-sm text-white/70">
        <li>Sign in to b→come at <a href="https://b-come.ai" target="_blank" rel="noreferrer">b-come.ai</a>.</li>
        <li>Go to <strong>Settings</strong>.</li>
        <li>Scroll to the "Danger zone" section and click <strong>Delete my account</strong>.</li>
        <li>Confirm — your account and all associated data will be removed within 30 days.</li>
      </ol>

      <h2>Option 2 — Request deletion by email</h2>
      <p>
        If you signed up with Facebook, Google, or a magic link and can't sign in, email us at{" "}
        <a href="mailto:hello@b-come.ai">hello@b-come.ai</a> from the address that owns the account
        with the subject line <code>Delete my account</code>. Include:
      </p>
      <ul>
        <li>The email address of the account you want deleted.</li>
        <li>(Optional) The reason you're leaving — helpful feedback but not required.</li>
      </ul>
      <p>
        We will confirm receipt within 2 business days and complete the deletion within 30 days.
      </p>

      <h2>What gets deleted</h2>
      <ul>
        <li>Your profile, name, and email.</li>
        <li>Your goals, milestones, tasks, habits, and progress logs.</li>
        <li>Your journal entries, check-ins, coach messages, and coach memory.</li>
        <li>Your vision-board items, uploaded images, and generated images.</li>
        <li>Your sports-form videos and AI feedback sessions.</li>
        <li>Your connected integrations (Google, Facebook, Plaid) — access tokens are revoked.</li>
      </ul>

      <h2>What we keep (and why)</h2>
      <ul>
        <li>Billing and tax records for up to 7 years, where required by law.</li>
        <li>Anonymized, aggregated usage statistics that cannot be tied back to you.</li>
        <li>Records of legally required communications (fraud, abuse, or law enforcement requests).</li>
      </ul>

      <h2>Removing b→come from your Facebook account</h2>
      <p>
        If you connected Facebook Login and just want to disconnect b→come without deleting your data:
      </p>
      <ol className="mt-3 list-decimal space-y-2 pl-6 text-sm text-white/70">
        <li>Go to <a href="https://www.facebook.com/settings?tab=applications" target="_blank" rel="noreferrer">Facebook Settings → Apps and Websites</a>.</li>
        <li>Find <strong>b→come</strong> in the list.</li>
        <li>Click <strong>Remove</strong>.</li>
      </ol>
      <p>
        This revokes Facebook's connection to your b→come account but does not delete the b→come
        account itself. To fully delete the account, follow Option 1 or Option 2 above.
      </p>

      <h2>Questions?</h2>
      <p>
        Email <a href="mailto:hello@b-come.ai">hello@b-come.ai</a> — we typically respond within 5
        business days.
      </p>
    </LegalShell>
  );
}
